import React from 'react';
import { motion } from 'framer-motion';
export function FinalCtaSection() {
  return <section className="py-16 px-4 sm:px-6 lg:px-8 bg-brand-white relative overflow-hidden border-t border-brand-gold/20" data-id="element-30">
      {/* Background Effects */}
      <div className="absolute inset-0 z-0" data-id="element-31">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(200,149,43,0.1)_0%,transparent_70%)]" data-id="element-32" />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto text-center" data-id="element-33">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-34">
          <h2 className="font-heading font-bold text-4xl md:text-6xl uppercase tracking-tight text-brand-text mb-8 leading-tight" data-id="element-35">
            Reclutar más no arregla una agencia rota
            <br data-id="element-36" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-gold to-brand-gold-bright" data-id="element-37">
              Construir control sí
            </span>
          </h2>

          <p className="text-xl md:text-2xl text-brand-text-muted mb-12 max-w-2xl mx-auto" data-id="element-38">
            Entra a Skool, elige tu módulo y empieza a construir una operación
            con estructura.
          </p>

          <div className="flex flex-col items-center" data-id="element-39">
            <a href="https://www.skool.com/reclutas-digitales-4277/about" target="_blank" rel="noopener noreferrer" className="px-12 py-6 bg-gradient-to-r from-brand-gold to-brand-gold-bright text-brand-black font-heading font-bold text-xl uppercase tracking-wide rounded-md hover:shadow-[0_0_30px_rgba(232,184,74,0.6)] transition-all duration-300 transform hover:-translate-y-1 mb-8 w-full sm:w-auto" data-id="element-40">
              ENTRAR A SKOOL
            </a>

            <p className="text-brand-gold font-medium text-sm md:text-base uppercase tracking-widest" data-id="element-41">
              BUILD desde $19/mes{' '}
              <span className="mx-2 text-brand-text-muted/30" data-id="element-42">|</span> TRACK
              desde $47/mes{' '}
              <span className="mx-2 text-brand-text-muted/30" data-id="element-43">|</span> SCALE
              desde $97/mes
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}